import React, { useEffect, useState } from 'react';
function getNextSession(): Date {
  const now = new Date();
  // Amsterdam time sessions: 10:00, 13:00, 20:00 (CET = UTC+1, CEST = UTC+2)
  // We'll work in local time and use fixed session hours
  const sessionHours = [10, 13, 20];
  // Get current time in Amsterdam
  const amsterdam = new Date(now.toLocaleString('en-US', {
    timeZone: 'Europe/Amsterdam'
  }));
  for (const hour of sessionHours) {
    const session = new Date(amsterdam);
    session.setHours(hour, 0, 0, 0);
    if (session > amsterdam) {
      // Convert back: calculate the diff and add to "now"
      const diff = session.getTime() - amsterdam.getTime();
      return new Date(now.getTime() + diff);
    }
  }
  // Next day, first session (10:00)
  const tomorrow = new Date(amsterdam);
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(10, 0, 0, 0);
  const diff = tomorrow.getTime() - amsterdam.getTime();
  return new Date(now.getTime() + diff);
}
function formatTime(totalSeconds: number) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return {
    hours,
    minutes,
    seconds
  };
}
export function CountdownScarcity() {
  const [secondsLeft, setSecondsLeft] = useState(0);
  useEffect(() => {
    const updateCountdown = () => {
      const target = getNextSession();
      const diff = Math.max(0, Math.floor((target.getTime() - Date.now()) / 1000));
      setSecondsLeft(diff);
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);
  const {
    hours,
    minutes,
    seconds
  } = formatTime(secondsLeft);
  const getSpotsLeft = () => {
    const totalHours = secondsLeft / 3600;
    if (totalHours > 6) return 9;
    if (totalHours > 5) return 8;
    if (totalHours > 4) return 7;
    if (totalHours > 3) return 6;
    if (totalHours > 2) return 5;
    if (totalHours > 1.5) return 4;
    if (totalHours > 1) return 3;
    return 2;
  };
  const spotsLeft = getSpotsLeft();
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="flex flex-col items-center mt-1 w-full max-w-[440px]" data-id="element-36">
      {/* Hand-drawn arrow pointing up to form */}
      <svg width="36" height="48" viewBox="0 0 36 48" fill="none" className="text-brand-coral mb-1 animate-bounce" style={{
      animationDuration: '2s'
    }} data-id="element-37">
        {/* Arrow shaft - wavy hand-drawn feel */}
        <path d="M18 46 C16 38, 14 30, 16 22 C17 16, 19 10, 18 4" stroke="currentColor" strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-38" />
        {/* Arrow head */}
        <path d="M10 14 C13 8, 16 3, 18 1 C20 3, 23 8, 26 14" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-39" />
      </svg>

      {/* Timer */}
      <p className="text-sm text-gray-500 font-medium mb-2" data-id="element-40">
        Het volgende webinar start over:
      </p>
      <div className="flex items-center gap-2 mb-3" data-id="element-41">
        <div className="bg-white border border-teal-100 rounded-xl py-2 shadow-sm text-center w-[56px]" data-id="element-42">
          <span className="text-2xl font-bold text-brand-mint font-mono tabular-nums" data-id="element-43">
            {pad(hours)}
          </span>
          <p className="text-[10px] text-gray-400 font-medium uppercase tracking-wider" data-id="element-44">
            uur
          </p>
        </div>
        <span className="text-brand-mint font-bold text-xl" data-id="element-45">:</span>
        <div className="bg-white border border-teal-100 rounded-xl py-2 shadow-sm text-center w-[56px]" data-id="element-46">
          <span className="text-2xl font-bold text-brand-mint font-mono tabular-nums" data-id="element-47">
            {pad(minutes)}
          </span>
          <p className="text-[10px] text-gray-400 font-medium uppercase tracking-wider" data-id="element-48">
            min
          </p>
        </div>
        <span className="text-brand-mint font-bold text-xl" data-id="element-49">:</span>
        <div className="bg-white border border-teal-100 rounded-xl py-2 shadow-sm text-center w-[56px]" data-id="element-50">
          <span className="text-2xl font-bold text-brand-mint font-mono tabular-nums" data-id="element-51">
            {pad(seconds)}
          </span>
          <p className="text-[10px] text-gray-400 font-medium uppercase tracking-wider" data-id="element-52">
            sec
          </p>
        </div>
      </div>

      {/* Scarcity */}
      <p className="text-base text-gray-700 font-semibold" data-id="element-53">
        Nog{' '}
        <span className="relative inline-block text-red-400 mx-0.5" data-id="element-54">
          <span className="line-through decoration-red-400 decoration-wavy decoration-2" data-id="element-55">
            50
          </span>
          {/* Hand-drawn strikethrough SVG overlay */}
          <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 30 20" preserveAspectRatio="none" data-id="element-56">
            <path d="M2 12 C8 8, 14 14, 28 10" stroke="#E8614A" strokeWidth="2.5" strokeLinecap="round" fill="none" data-id="element-57" />
          </svg>
        </span>{' '}
        <span className="text-teal-500 font-bold text-xl" data-id="element-58">{spotsLeft}</span>{' '}
        plekken beschikbaar
      </p>
    </div>;
}